import * as React from 'react'

type Scalar = boolean | number | string | bigint | null | undefined

export function useCallback<T extends (...args: any[]) => any>(callback: T, deps: Scalar[]) {
  return React.useCallback(callback, deps) // eslint-disable-line react-hooks/exhaustive-deps
}

export function useUnsafeCallback<T extends (...args: any[]) => any>(
  callback: T,
  deps: React.DependencyList
) {
  return React.useCallback(callback, deps) // eslint-disable-line react-hooks/exhaustive-deps
}
